import { SVGProps } from "react";

export const ArrowDownIcon = ({ color = "#292A2F", ...props }: SVGProps<SVGSVGElement>) => (
  <svg width="7" height="9" viewBox="0 0 7 9" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M4.03237 8.80105L6.80816 6.02526C7.06395 5.76947 7.06395 5.34316 6.80816 5.08737C6.55237 4.83158 6.12605 4.83158 5.87026 5.08737L4.22184 6.72632V0.663158C4.22184 0.293684 3.92816 -1.34274e-07 3.55868 -1.50425e-07C3.18921 -1.66575e-07 2.89553 0.293684 2.89553 0.663158V6.72632L1.25658 5.08737C1.00079 4.83158 0.574475 4.83158 0.318685 5.08737C0.186054 5.22 0.119737 5.39053 0.119737 5.56105C0.119737 5.73158 0.186054 5.90211 0.318685 6.03474L3.085 8.80105C3.20816 8.92421 3.37868 9 3.55868 9C3.73868 9 3.90921 8.93368 4.03237 8.80105Z"
      fill={color}
      fillOpacity="0.7"
    />
  </svg>
);
